import { Input } from '@/components/ui/Input';
import { filterArabicName, filterLatinName } from '@finvox/shared/text-locale';
import { cn } from '@/lib/cn';
import { type InputHTMLAttributes, forwardRef } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  locale: 'en' | 'ar';
  value: string;
  onValueChange: (value: string) => void;
};

export const LocaleNameInput = forwardRef<HTMLInputElement, Props>(function LocaleNameInput(
  { locale, value, onValueChange, className, ...props },
  ref
) {
  const filter = locale === 'en' ? filterLatinName : filterArabicName;

  return (
    <Input
      ref={ref}
      lang={locale === 'en' ? 'en' : 'ar'}
      dir={locale === 'ar' ? 'rtl' : 'ltr'}
      className={cn(locale === 'ar' && 'text-end', className)}
      value={value}
      onChange={(e) => onValueChange(filter(e.target.value))}
      {...props}
    />
  );
});
